module.exports = __webpack_public_path__ + "img/hiddenRisk_uncheck.e1417d10.png";